import type { RestoreJob } from '@repo/api-gw-sdk';

import {
  destinationBucket,
  destinationContainer,
  destinationPrefix,
  diskId,
  imageId,
  instanceId,
  queryResults,
  restoredPersistentVolumes,
  restoredResourceName,
  snapshotId,
  volumeId,
} from '@/components/queryBuilder/outputResourcesProperties';
import {
  backupRegion,
  databaseFilter,
  encryptionKey,
  instanceProfile,
  instanceType,
  jobId,
  jobResourceName,
  jobTemporalLink,
  machineType,
  networkInterface,
  partialRestoreData,
  resourceId,
  resourceType,
  restoreAccountId,
  restoreJobInitiatorId,
  restoreRegion,
  securityGroups,
  sourceAccountId,
  sourceRegion,
  subnet,
  subnetGroup,
  tags,
  vault,
  vmSize,
  zone,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const restoreJobItemFields = [
  jobId,
  jobTemporalLink,
  jobResourceName,
  resourceType,
  resourceId,
  restoreJobInitiatorId,
  partialRestoreData,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryFromFields = [
  vault,
  backupRegion,
  sourceAccountId,
  sourceRegion,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryToFields = [
  restoreAccountId,
  restoreRegion,
  restoredResourceName,
  queryResults,
  snapshotId,
  instanceId,
  volumeId,
  imageId,
  diskId,
  restoredPersistentVolumes,
  destinationBucket,
  destinationContainer,
  destinationPrefix,
] as FilterProperty<RestoreJob>[];

export const restoreJobConfigurationFields = [
  databaseFilter,
  subnet,
  subnetGroup,
  instanceType,
  securityGroups,
  instanceProfile,
  encryptionKey,
  tags,
  vmSize,
  networkInterface,
  zone,
  machineType,
] as FilterProperty<RestoreJob>[];
